import { apiClientV2 } from '@/api/ApiClientV2';
import { ClientApp } from '@/models/client/models';
import { RouterHandler } from '@/router/routerHandler';
import { authStore } from '@/store/modules/auth/auth';
import { globalStore } from '@/store/modules/global';
import { AxiosRequestConfig } from 'axios';
import { beforeEnterMonitoringApp } from './router';

export async function initializeStandaloneMonitoringDashboard(
  routerHandler: RouterHandler,
): Promise<void> {
  const token = await getFromRoute(routerHandler, 'token');
  const axiosConfig: AxiosRequestConfig = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  authStore.setAxiosConfig(axiosConfig);
  apiClientV2.setAxiosConfig(axiosConfig);

  const clientAppId = await getFromRoute(routerHandler, 'client_app');
  const clientApp = await apiClientV2.get<ClientApp>(ClientApp, clientAppId);

  globalStore.setSelectedObject({
    objectType: 'clientApp',
    object: clientApp,
  });
  await beforeEnterMonitoringApp();
}

export async function getFromRoute(
  routerHandler: RouterHandler,
  key: string,
): Promise<string> {
  const value = routerHandler.query('')[key];
  if (!value) {
    throw new Error(`${key} not provided`);
  }
  return value;
}
